import React, { useEffect } from "react";
import "./Reject_Modal.css";
import { Button, Modal } from "react-bootstrap";
import Successfull_Lottie from "./Reject_Lottie/Reject_Lottie";

function Reject_Modal(props) {
  const { message, subMessage } = props; // Extracting 'message' prop

  useEffect(() => {
    setTimeout(() => {
      props.onHide();
    }, 3000);
  }, [props.show]);

  return (
    <>
      <div className="Successfull_Modal_sec">
        <Modal
          className="Successfull_Modal"
          {...props}
          size="sm"
          aria-labelledby="contained-modal-title-vcenter"
          centered
        >
          <Modal.Header closeButton>
            {" "}
            <Modal.Title>Rejected</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <div className="lottie-holder">
              {" "}
              <Successfull_Lottie />
            </div>
            <div className="text-center">
              <p>{message}</p> {/* Displaying the 'message' prop */}
              <sub>{subMessage}</sub>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    </>
  );
}

export default Reject_Modal;
